import React from 'react';
import HeroSection from './components/HeroSection/HeroSection';
import AdoptionSection from './components/AdoptionSection/AdoptionSection';
import TopScreensSection from './components/TopScreensSection/TopScreensSection';
import WhatsNewSection from './components/WhatsNewSection/WhatsNewSection';
import ComingSoonSection from './components/ComingSoonSection/ComingSoonSection';

function App() {
  return (
    <div className="App">
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      
      <main id="main-content">
        <HeroSection />
        <AdoptionSection />
        <TopScreensSection />
        <WhatsNewSection />
        <ComingSoonSection />
      </main>
      
      <footer style={{ 
        textAlign: 'center', 
        padding: 'var(--spacing-xl)', 
        backgroundColor: 'var(--color-gray-light)',
        color: 'var(--color-gray-dark)'
      }}>
        <p>&copy; 2026 The Ohio State University. All rights reserved.</p>
        <p>Any questions? Contact <a href="mailto:osumobilefeedback@lists.osu.edu" style={{ color: 'var(--color-scarlet)' }}>osumobilefeedback@lists.osu.edu</a></p>
      </footer>
    </div>
  );
}

export default App;
